<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col>
        <v-card>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title
                class="text-h5"
              >FAQ's</v-card-title>
              <v-card-subtitle
                class="text--secondary"
              >Stell uns doch deine Frage per E-Mail.</v-card-subtitle>
              <v-card-actions>
                <v-btn
                  class="primary ml-2"
                  small
                  @click="send_mail"
                >
                  E-Mail senden
                </v-btn>
              </v-card-actions>
            </div>
            <v-avatar
              class="ma-3"
              size="125"
              tile
              @click="send_mail"
            >
              <v-img :src="require('@/assets/faq.png')"></v-img>
            </v-avatar>
          </div>
        </v-card>

        <v-expansion-panels
          class="mt-3"
        >
          <v-expansion-panel
            v-for="(item,i) in all_faqs"
            :key="i"
          >
            <v-expansion-panel-header>
              <div>
                <v-icon
                  class="mr-1"
                >
                  {{ item.icon }}
                </v-icon>
                {{ item.question }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              {{item.answer}}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="mt-6">
          <v-card-title class="text-h5">Patch Notes</v-card-title>
          <v-card-subtitle class="text--secondary">Was hat sich zuletzt in elocom getan?</v-card-subtitle>
          <v-card-text>
            <v-timeline
              dense
              align-top
            >
              <v-timeline-item
                v-for="(entry, idx) in patch_notes"
                :key="idx"
                small
                color="primary"
                fill-dot
              >
                <template #icon>
                  <v-icon dark small>mdi-package-variant-closed</v-icon>
                </template>
                <div class="d-flex flex-wrap align-center mb-2" style="gap: 8px">
                  <span class="font-weight-bold">{{ format_date(entry.date) }}</span>
                  <span
                    v-if="entry.title"
                    class="text--secondary"
                  >— {{ entry.title }}</span>
                </div>
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item
                    v-for="(change, cidx) in entry.changes"
                    :key="cidx"
                    class="px-0"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-chip
                        :color="change_meta(change.type).color"
                        x-small
                        label
                        dark
                      >
                        {{ change_meta(change.type).label }}
                      </v-chip>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title style="white-space: normal">{{ change.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import patchNotes from '@/assets/patch_notes.json'

export default {
  name: "FAQ",
  data: () => ({
    search: '',
    patch_notes: patchNotes,
    all_faqs: [
      {
        icon: 'mdi-clipboard-list-outline',
        question: 'Warum entspricht der angezeigte Status nicht dem auf dem Funkgerät?',
        answer: 'Im Rahmen von beispielsweise Tagesabmeldungen kann es vorkommen, dass ein Status manuell durch die Leitstelle gesetzt wird. In diesem Fall kann der Status über das Tableau (sofern die entsprechende Berechtigung vorliegt) korrigiert werden. Alternativ besteht die Möglichkeit, den Status durch einen Statuswechsel am Funkgerät, z. B. 1-2, zu aktualisieren.'
      },
      {
        icon: 'mdi-phone-log',
        question: 'Kann ich das Telefonbuch in meine OFW-Telefonanlage integrieren?',
        answer: 'Ja, das ist möglich. Wir können einen zusätzlichen CSV-Download bereitstellen oder, sofern technisch umsetzbar, eine direkte Verbindung einrichten.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Wie sperre ich einen verlorenen Transponder?',
        answer: 'Über die Aktionsspalte in der Benutzerliste können Benutzer gesperrt werden. Sollte der Transponder wiedergefunden werden, kannst du ihn einfach wieder entsperren.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Kann ich Transponder selbstständig sperren und entsperren?',
        answer: 'Ja, jeder Benutzer kann Transponder eigenständig sperren und auch wieder entsperren. Dadurch können verlorene Transponder schnell und unkompliziert deaktiviert werden, um Missbrauch zu verhindern. Wird ein Transponder wiedergefunden, kannst du ihn einfach wieder freischalten.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Wie lange dauert es, bis Änderungen an Berechtigungen wirksam sind?',
        answer: 'Änderungen werden in der Regel innerhalb weniger Sekunden auf die Access-Manager übertragen.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Warum kann ich meinen Kameraden nicht umbenennen?',
        answer: 'Du kannst nur Kameraden umbenennen, die ausschließlich von dir verwaltet werden. Der Grund dafür ist, dass beim Weitergeben eines Transponders möglicherweise noch fremde Schließberechtigungen vorhanden sind, die zuerst gelöscht werden müssen.'
      },
      /*{
        icon: 'mdi-key-chain-variant',
        question: 'Mein Kamerad hat bereits einen privaten Transponder und möchte diesen weiterverwenden. Geht das?',
        answer: 'Private Transponder mit MIFARE® DESFire® Technologie (13,56 MHz) vom Typ EV2 mit 4 kB Speicher können verwendet werden. Halte den Transponder dazu an zwei verschiedene Türschlösser und sende eine E-Mail mit dem Namen des Kameraden sowie Datum und Uhrzeit der Türbuchung an it@stadtfeuerwehr-garbsen.de.'
      },*/
      {
        icon: 'mdi-key-chain-variant',
        question: 'Warum verwenden wir statt des Transponders nicht das RFID-Tag im digitalen Meldeempfänger?',
        answer: 'Das RFID-Tag im digitalen Meldeempfänger nutzt eine andere Frequenz und ist leider nicht mit unserem Schließsystem kompatibel.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Wie ändere ich die Schließgruppen oder ordne eine Tür neu zu?',
        answer: 'Bitte sende eine E-Mail mit der gewünschten neuen Zuordnung an it@stadtfeuerwehr-garbsen.de.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Habe ich weiterhin Zugang zum Gerätehaus, wenn die Internetverbindung ausfällt?',
        answer: 'Ja! Die Schließberechtigungen werden in den sogenannten Access-Managern innerhalb der Gerätehäuser zwischengespeichert. Der Zutritt zum Gerätehaus ist weiterhin problemlos möglich.'
      },
      {
        icon: 'mdi-key-chain-variant',
        question: 'Habe ich weiterhin Zugang zum Gerätehaus, wenn der Strom ausfällt?',
        answer: 'Das hängt von der Situation ab. Jede Tür ist mit einem Access-Manager verbunden. Fällt der Access-Manager aus, können die zugehörigen Türschlösser die Schließberechtigungen nicht prüfen, wodurch das Öffnen der Tür fehlschlägt. Für bestimmte Transponder ist ein Notfallzugang hinterlegt, bei dem einzelne Schließberechtigungen direkt im Türschloss gespeichert sind. Aus technischen Gründen ist der Notfallzugang nur für einen kleinen Personenkreis (z. B. OBM, GW, BvD) vorgesehen. Diese Personen sind in der Benutzerliste markiert. Außerdem muss der Transponder mindestens einmal zuvor an der entsprechenden Tür verwendet worden sein. In einigen Gebäuden wird einer der Access-Manager über eine USV mit Strom versorgt, sodass einige Türen möglicherweise weiterhin funktioniert.'
      }
    ]
  }),
  methods: {
    send_mail(){
      const email = "it@stadtfeuerwehr-garbsen.de";
      const subject = "Frage";
      const body = "Hallo zusammen,\r\n\r\nich habe folgende Frage:\r\n\r\n\r\nMetadaten aus elocom:\r\n" + this.$store.state.user.cn + this.$store.state.user.pms + this.$store.state.general.global_search;
      const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      window.location.href = mailtoLink; // Öffnet das E-Mail-Programm
    },
    format_date(iso){
      if (!iso) return ''
      const [y, m, d] = iso.split('-')
      return `${d}.${m}.${y}`
    },
    change_meta(type){
      switch (type) {
        case 'new':      return { color: 'success', label: 'Neu' }
        case 'improved': return { color: 'info',    label: 'Verbessert' }
        case 'fixed':    return { color: 'warning', label: 'Behoben' }
        default:         return { color: 'grey',    label: type || '—' }
      }
    }
  },
  computed: {
    filtered_faqs(){
      let globalSearch = this.$store.state.general.global_search
      return this.all_faqs.filter((item) =>
        (item.question.toLowerCase().includes(this.search.toLowerCase()) || item.answer.toLowerCase().includes(this.search.toLowerCase())) &&
        (item.question.toLowerCase().includes(globalSearch) || item.answer.toLowerCase().includes(globalSearch))
      )
    }
  }
};
</script>

<style scoped>

</style>
